var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"register-pages-wrapper login-page-wrapper"},[_c('navbar-main'),_c('div',{staticClass:"register-page-content login-page-content px-3"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }